import { useConfig } from 'shared/config/ConfigContext';
import useFetch from 'shared/hooks/useFetch';
import { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';
import { deletePriceOverride } from '@/api/api';
import type { PriceOverride } from '@/domain';
import { usePriceCalendarInvalidate } from '@/hooks/usePriceCalendar';

type DateFromTo = { itemId: string; startDate: string; endDate: string };

const url = (apiExternalUrl: string, adId: string) => `${apiExternalUrl}/price/override/${adId}`;

export const usePriceOverride = (adId: string) => {
    const { apiExternalUrl } = useConfig();
    return useFetch<PriceOverride[]>({ url: url(apiExternalUrl, adId) });
};

export const usePriceOverrideDelete = (adId: string) => {
    const { apiExternalUrl } = useConfig();
    const post = async (_url: string, { arg }: { arg: DateFromTo }) => deletePriceOverride(apiExternalUrl, arg);
    const { trigger, ...rest } = useSWRMutation(url(apiExternalUrl, adId), post, { throwOnError: false });
    const { invalidate } = usePriceCalendarInvalidate(adId);

    const triggerWithSideEffect = async (arg: DateFromTo) => {
        await trigger(arg);

        if (invalidate) {
            await invalidate();
        }
    };

    return { trigger: triggerWithSideEffect, ...rest };
};

export const usePriceOverrideInvalidate = (adId: string) => {
    const { apiExternalUrl } = useConfig();
    const invalidate = () => mutate(url(apiExternalUrl, adId));
    return { invalidate };
};
